import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { Subject, SubjectNew, SubjectUpdate } from "../../_objects/subject";
import { SubjectContractService } from "../interfaces/subject-contract.service";
import { ApiService } from "../base/api-base.service";
import { NetworkStatusService } from "../network-status.service";
import { SubjectOfflineService } from "../offline/subject-offline.service";
import { SubjectOnlineService } from "../online/subject-online.service";

@Injectable()
export class SubjectService extends ApiService<SubjectContractService> implements SubjectContractService {
  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: SubjectOfflineService,
    protected onlineService: SubjectOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
  }

  // SB01 GET /api/v1/subjects
  getSubjects(subjectModelId?: string, enabledOnly?: boolean, rootOnly?: boolean): Observable<Subject[]> {
    return this.service.getSubjects(subjectModelId, enabledOnly, rootOnly);
  }

  // SB02 GET /api/v1/subjects/{subjectId}
  getSubject(id: string, version?: number): Observable<Subject> {
    return this.service.getSubject(id, version);
  }

  // SB03 POST /api/v1/subjects
  addSubject(subject: SubjectNew): Observable<Subject> {
    return this.service.addSubject(subject);
  }

  // SB04 PUT /api/v1/subjects/{subjectId}
  updateSubject(subject: SubjectUpdate): Observable<Subject> {
    return this.service.updateSubject(subject);
  }

  // SB05 PUT /api/v1/subjects/{subjectId}
  deleteSubject(id: string): Observable<Subject> {
    return this.service.deleteSubject(id);
  }
}
